import React, { useContext } from "react";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useDocumentTitle } from "usehooks-ts";
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import { useLocation, useNavigate } from "react-router-dom";
import { NoodleModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { isHttpOK } from "nood-comp/src/net/xhr";
import VoucherCodeEditor from "src/routes/orgs/membership/vouchers/voucher-code/VoucherCodeEditor";
import VoucherCodeView from "src/routes/orgs/membership/vouchers/voucher-code/VoucherCodeView";
import VoucherCodes from "src/routes/orgs/membership/vouchers/voucher-code/VoucherCodes";
import { msg } from "src/app/msg";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
export default function VoucherCodesIndex(props) {
  var _useLocation;
  useDocumentTitle(msg.title("Voucher Code"));
  var id = useURLParam('id');
  var modalCtx = useContext(NoodleModalContext);
  var navigate = useNavigate();
  var queryString = (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.search;
  var items = [{
    id: 'list',
    label: 'Voucher Codes',
    icon: 'list',
    content: /*#__PURE__*/React.createElement(VoucherCodes, null),
    queryString: {
      id: undefined
    }
  }, {
    id: 'add',
    label: 'Add',
    icon: 'plus',
    content: /*#__PURE__*/React.createElement(VoucherCodeEditor, null),
    queryString: {
      id: undefined
    }
  }, {
    id: 'view',
    label: 'View',
    icon: 'eye',
    show: id !== null,
    content: /*#__PURE__*/React.createElement(VoucherCodeView, null),
    queryString: [{
      id: id
    }]
  }, {
    id: 'edit',
    label: 'Edit',
    icon: 'edit-2',
    show: id !== null,
    content: /*#__PURE__*/React.createElement(VoucherCodeEditor, null),
    queryString: {
      id: id
    }
  }, {
    id: 'delete',
    label: 'Delete',
    icon: 'x',
    show: id !== null,
    __click: function __click(e) {
      modalCtx.__confirmDelete({
        entity: "Voucher Code",
        endpoint: "/voucher-code/".concat(id),
        __onAfterDelete: function __onAfterDelete(response) {
          if (isHttpOK(response)) {
            navigate(queryStringMod({
              "do": "list",
              id: undefined
            }));
          }
        }
      });
    }
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Voucher Codes"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: items
  }));
}